// Read API URL dynamically from .env
const rawApiUrl = (import.meta.env.VITE_API_URL || '').trim();

if (!rawApiUrl && import.meta.env.DEV) {
  console.warn('⚠️ [Config] VITE_API_URL is missing in .env file!');
}

// Normalize origin (remove quotes, trailing slashes, and accidental trailing /api)
const cleanOrigin = rawApiUrl
  .replace(/^["']|["']$/g, '')
  .replace(/\/+$/, '')
  .replace(/\/api$/, '');

// 1. Base URL for Axios & direct file upload fetch calls (guaranteed to end with /api/)
export const baseUrl = cleanOrigin ? `${cleanOrigin}/api/` : '/api/';

// 2. Base domain origin
export const apiOrigin = cleanOrigin;

// 3. Broadcasting authentication endpoint for Pusher
export const broadcastingAuthUrl = cleanOrigin ? `${cleanOrigin}/broadcasting/auth` : '/broadcasting/auth';

import {
  getActiveRestaurantSystemId,
  setActiveRestaurantSystemId,
  getActiveRestaurantId,
  setActiveRestaurantId,
  getActiveClientId,
} from "@/lib/idProvider";

export const getRestaurantSystemId = getActiveRestaurantSystemId;
export const setRestaurantSystemId = setActiveRestaurantSystemId;
export const getRestaurantId = getActiveRestaurantId;
export const setRestaurantId = setActiveRestaurantId;
export const getClientId = getActiveClientId;

// Dynamic fallbacks
export const restaurant_system_id = getActiveRestaurantSystemId();
export const restaurant_id = getActiveRestaurantId();

export const getStaffDirectory = (resId) => `restaurant/${resId || getActiveRestaurantId()}/staff/image`;
export const staffDfdirectory = `restaurant/${getActiveRestaurantId()}/staff/image`;
export const menuManageDirectory = `restaurant/${getActiveRestaurantId()}/staff/image`;

export const departmentUrl = "/staff-departments";
// export const staffRoleUrl = "/staff-departments/";
export const staffUrl = "/staff";
export const loginUrl = "/user-login";
export const verifyPinUrl = "/verify-pin";
export const getUserUrl = (clientId) => `/client/${clientId || getActiveClientId() || "878cf622-066f-4dc4-bc92-5b1efd513846"}`;
export const userUrl = `/client/${getActiveClientId() || "878cf622-066f-4dc4-bc92-5b1efd513846"}`;
export const foodUrl = "/foods";
export const categoryUrl = "/categories";
export const ingredientUrl = "/ingredients";
export const addonUrl = "/addons";
export const unitUrl = "/units";
export const orderUrl = "/orders";
export const attributeUrl = "/attributes";
export const attributeOptionUrl = "/attribute-options";
export const orderItemUrl = "/order-items";
export const orderTypesUrl = "/order-types";
export const restaurantUrl = "/restaurant";
export const customerUrl = "/customers";
export const addressBooksUrl = "/address-books";
export const customersUrl = "/customers";
export const voucherUrl = "/vouchers";
export const voucherHistoryUrl = "/voucher-histories";
export const c2cVoucherUrl = "/c2c-gift-cards";
export const concessionUrl = "/concession-treats";
export const pointBasedUrl = "/point-base-cards";
export const pointBasedHistoryUrl = "/point-base-card-histories";


export const getFloorGetUrl = (resId) => `/restaurants/${resId || getActiveRestaurantId()}/floors`;
export const floorGetUrl = `/restaurants/${getActiveRestaurantId()}/floors`;
export const floorUrl = "/floors";

export const getRoomGetUrl = (resId) => `/restaurants/${resId || getActiveRestaurantId()}/rooms`;
export const roomGetUrl = `/restaurants/${getActiveRestaurantId()}/rooms`;
export const roomUrl = "/rooms";
export const callLogUrl = "/call-logs";

export const giftCardUrl = "/gift-cards";
export const giftCardHistoryUrl = "/gift-card-histories";


export const restaurantStaffUrl = "my-restaurant" 

export default baseUrl;